import type { CSSProperties } from "react";
import { Link, useRouterState } from "@tanstack/react-router";
import { useT } from "../i18n";
import { Zeichen } from "../bausteine/Zeichen";
import { aktivesFach, type Handyweg } from "./handywege";
import { useErscheinungsbild } from "./erscheinungsbild";

/* ══════════════════════════════════════════════════════════════════
   Die Marke im Kopf am Telefon — Signal, Paket 5 (07.10.2026).

   **Logo Variante A** (Luca, 07.10.2026): die Bildmarke — der Mann aus dem
   Logo — einfarbig in Tinte, daneben „**Machine** Office" in der Schrift der
   Anwendung. Das volle, zweifarbige Logo zerfaserte bei 40 px Höhe und biss
   sich mit dem Grund („weißer Schriftzug an weißem Schriftzug"). Die Bildmarke
   ist eine Maske (`public/logo-bildmarke.png`) und nimmt `currentColor` an —
   hell und dunkel folgen von selbst, ohne zweites Bild. Das volle Logo mit
   Leistungszeile steht weiter auf der Anmeldung.

   **Auf einer Unterseite von „Mehr" steht der Rückweg statt der Marke**
   (Sollbild: „‹ Mehr / Aufträge"). Unterseite heißt: Das aktive Fach ist
   „Mehr", und man steht eine Ebene darunter (`/auftraege`, `/abrechnung`).
   Tiefer — eine Akte mit eigenem Pfeil im Seitenkopf — bleibt die Marke,
   sonst stünden zwei Rückwege übereinander.
   ══════════════════════════════════════════════════════════════════ */
export function Telefonmarke({ punkte }: { punkte: Handyweg[] }) {
  const t = useT();
  const bild = useErscheinungsbild();
  const { location } = useRouterState();
  const pfad = location.pathname;
  const fach = punkte.length ? aktivesFach(punkte, pfad) : null;
  const unterMehr = fach === "/mehr" && pfad !== "/mehr" && pfad.split("/").filter(Boolean).length === 1;
  if (unterMehr) {
    return (
      <Link to="/mehr" className="t-rueckweg" preload={false}>
        <Zeichen name="weiter" />
        <span>{t("handyLeiste.mehr")}</span>
      </Link>
    );
  }
  return (
    <span className="t-marke" role="img" aria-label={t("app.logoAlt")}>
      {/* Eine hochgeladene Bildmarke (Einstellungen › Erscheinungsbild) ersetzt
          die Maske; sie wirkt über ihren Alphakanal, gefärbt wird in Tinte. */}
      <span
        className="t-bildmarke"
        aria-hidden="true"
        style={bild.logos.bildmarke ? ({ "--bildmarke": `url("${bild.logos.bildmarke}")` } as CSSProperties) : undefined}
      />
      <span className="t-wortmarke" aria-hidden="true"><b>{t("app.wortmarkeVorn")}</b> {t("app.wortmarkeHinten")}</span>
    </span>
  );
}
